import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acesso',
  templateUrl: './acesso.component.html',
  standalone: false,
  styleUrls: ['./acesso.component.scss']
})
export class AcessoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
